import o from "react";
import { useRouter as u } from "next/router";
import { q as f } from "./index.CVakAlTX.js";
import { r as l } from "./serializers.ClvJp8_D.js";
function p() {
  const e = u(), [a, r] = o.useState(null);
  return o.useEffect(() => {
    if (typeof window < "u" && e.isReady) {
      const n = f.parse(window.location.search.slice(1)), t = l(n.filters || ""), s = Object.fromEntries(
        Object.entries(e.query).filter(
          ([i]) => i !== "path" && !i.startsWith("filters.")
        )
      );
      Object.keys(s).length === 0 && Object.keys(t).length === 0 ? r(null) : r({ ...s, filters: t });
    }
  }, [e.query, e.isReady]), { queryParams: a, isReady: e.isReady };
}
export {
  p as u
};
